module.exports = __webpack_public_path__ + "img/phoenix_ash.82c3ce9c.png";